import isPermissionEnabled from "common/isPermissionEnabled"
import Breadcrumbs from "components/Common/Breadcrumb"
import Switch from "components/Shared/Switch"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap"
import {
  getGlobalSettingByType,
  updateGlobalSettingByType,
} from "store/actions/globalSettingAction"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import ConfirmModal from "components/Common/ConfirmModal"
const defaultValues = {
  hasGiftCardPurchaseEnabled: null,
  hasGiftCardFeatureEnabled: null,
  //   hasGiftCardRedeemEnabled: null,
  //   hasGiftCardAsPaymentMethodEnabled: null,
}

const EidiyahSettings = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Gift Card Settings ")

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { loading, isLoading, giftCardInfo } = useSelector(
    state => state.GlobalSettings
  )

  const [formValues, setFormValues] = useState(defaultValues)

  const { userRole, accountType } = useSelector(state => state.Login)
  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    edit: null,
  })
  const [showSaveModal, setShowSaveModal] = useState(false)

  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      40,
      "gift_card_settings_1",
      accountType
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      40,
      "gift_card_settings_3",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    } else {
      fetchDetails()
    }
    setUsersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  useEffect(() => {
    if (giftCardInfo && giftCardInfo?.giftCardInfo) {
      const { hasGiftCardPurchaseEnabled , hasGiftCardFeatureEnabled } = giftCardInfo?.giftCardInfo
      setFormValues({
        hasGiftCardPurchaseEnabled,
        hasGiftCardFeatureEnabled,
      })
    }
  }, [giftCardInfo])

  const fetchDetails = () => {
    const payload = {
      type: "giftCardInfo",
    }
    dispatch(getGlobalSettingByType(payload))
  }

  const handleOnChange = key => {
    setFormValues(prevValues => ({
      ...prevValues,
      [key]: !prevValues[key],
    }))
  }

  const handleSave = () => {
    const { hasGiftCardPurchaseEnabled , hasGiftCardFeatureEnabled} = formValues || {}
    const payload = {
      id: giftCardInfo._id,
      type: "giftCardInfo",
      giftCardInfo: {
        hasGiftCardPurchaseEnabled,
        hasGiftCardFeatureEnabled,
      },
    }
    dispatch(updateGlobalSettingByType(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowSaveModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const confirmSave = () => {
    handleSave()
  }
  const cancelSave = () => {
    setShowSaveModal(false)
  }
  if (loading) return <Spinners />
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
        
            <Col lg={6}>
            <Card className="full_height_card">
              <CardBody>
                <CardTitle>{t("Gift Card Feature Settings")}</CardTitle>
                <span>
                  {t(
                    "When this setting is enabled, customers can access and use the Gift Card feature throughout the app."
                  )}
                </span>
                <Row>
                  <Col lg={12}>
                    <hr className="mt-3" />
                    <div className="d-flex justify-content-end align-items-center">
                      <Label
                        htmlFor="backgroundEmails"
                        className="col col-form-label"
                      >
                        {t("Enable Gift Card Feature on App")}
                      </Label>
                      <Switch
                        onClickHandler={() =>
                          handleOnChange("hasGiftCardFeatureEnabled")
                        }
                        isChecked={formValues.hasGiftCardFeatureEnabled}
                        disabled={!usersPermissions.edit}
                      />
                    </div>
                    <hr />
                  </Col>
                  {usersPermissions?.edit && (
                    <Col lg={12}>
                      <Button
                        color="success"
                        className="d-block ms-auto mt-4"
                        disabled={isLoading}
                        onClick={() => setShowSaveModal(true)}
                      >
                        {t("Save")}
                      </Button>
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col lg={6}>
          <Card className="full_height_card">
              <CardBody>
                <CardTitle>{t("Gift Card Purchase Settings")}</CardTitle>
                <span>
                  {t(
                    "When this setting is enabled, customers will be able purchase and share Gift Card with others."
                  )}
                </span>
                <Row>
                  <Col lg={12}>
                    <hr className="mt-3" />
                    <div className="d-flex justify-content-end align-items-center">
                      <Label
                        htmlFor="backgroundEmails"
                        className="col col-form-label"
                      >
                        {t("Allow Gift Card Purchase and Sharing")}
                      </Label>
                      <Switch
                        onClickHandler={() =>
                          handleOnChange("hasGiftCardPurchaseEnabled")
                        }
                        isChecked={formValues.hasGiftCardPurchaseEnabled}
                        disabled={!usersPermissions.edit}
                      />
                    </div>
                    <hr />
                  </Col>
                  {usersPermissions?.edit && (
                    <Col lg={12}>
                      <Button
                        color="success"
                        className="d-block ms-auto mt-4"
                        disabled={isLoading}
                        onClick={() => setShowSaveModal(true)}
                      >
                        {t("Save")}
                      </Button>
                    </Col>
                  )}
                </Row>
              </CardBody>
            </Card>
            </Col>
        </Row>
      </div>
      <ConfirmModal
        show={showSaveModal}
        onDeleteClick={confirmSave}
        onCloseClick={cancelSave}
        isLoading={isLoading}
        buttonText={t("Yes")}
        bodyTitle={t("Are you sure you want to save these settings?")}
      />
    </div>
  )
}

export default EidiyahSettings
